import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, Form, Button } from 'react-bootstrap';
import { Badge } from 'reactstrap';
import classnames from 'classnames';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import { fetchSTOrders } from '../action/action';
import { SORTING_ORDER } from '../../../constants/index';
import moment from 'moment';
import {
  Table,
  Row,
  Col,
  CardBody,
  CardTitle,
  CardHeader,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
  NavLink,
  Nav,
  NavItem,
} from 'reactstrap';

const STOrderList = () => {
  const uploadBaseUrl = process.env.REACT_APP_UPLOADS_PATH;
  const filePath = '/marketplace/seller_central/label/';
  const fileUrl = `${uploadBaseUrl}${filePath}`;

  const [btnprimary1, setBtnprimary1] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedShipment, setSelectedShipment] = useState(null);
  const [ActiveFilter, setActiveFilter] = useState(false);

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState();
  const [isShipmentOrVendorUpdated, setIsShipmentOrVendorUpdated] = useState(true);
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: '_date',
    order: SORTING_ORDER.ASC,
  });
  const [searchValue, setSearchValue] = useUrlSearchParams({ search: '' });
  const [statusValue, setStatusValue] = useUrlSearchParams({ activeTab: 'All' });
  const [isApiCall, setApiCall] = useState(0);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');

  useEffect(() => {
    setDataLoading(true);
    if (isApiCall === 0) {
      fetchSTOrders({
        params: {
          country: currentCountry,
          start: Number(paginationValue.page * limitValue.limit),
          limit: Number(limitValue.limit),
          sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
          search_qry: searchValue?.search,
          status: statusValue.activeTab,
          marketId: selectedVendor?.value,
          shippingType: selectedShipment?.value,
        },
        dispatch,
      });
      setTimeout(() => setApiCall(0), 8000);
    }
    setDataLoading(false);
  }, [
    paginationValue.page,
    limitValue,
    sortingValue.sort,
    searchValue.search,
    statusValue.activeTab,
  ]);

  const limitByValues = [5, 10, 20, 50];
  const { marketPlaceList = [], isLoading } = useSelector((state) => state.marketPlace);
  const [isDataLoading, setDataLoading] = useState(false);

  const { listOrders } = marketPlaceList;
  const orderData = listOrders?.orderList;

  const onDrawerClose = () => setOpen(false);
  let LsSts = 'New';

  const handlePagination = (e) => setPaginationValue({ page: e.target.value });
  const handleLimit = (e) => setLimitValue({ limit: Number(e) });
  const handleSearch = (e) => setSearchValue({ search: e.target.value });
  const toggleCustom = (tab) => setStatusValue({ activeTab: tab });

  let pageIndex = Number(listOrders?.start);

  const AdvanceFilterOnClick = (filterStatus) => {
    if (filterStatus === false) {
      setActiveFilter(true);
      setPosition('right');
      setOpen(!open);
    } else {
      setActiveFilter(false);
    }
  };

  const AdvanceFilterClear = () => {
    setActiveFilter(false);
    setSearchValue({ search: '' });
    setSelectedVendor(null);
    setSelectedShipment(null);
  };

  const optionGroup = [
    {
      label: 'Vendor',
      options: [
        { label: 'All', value: 'All' },
        { label: 'Amazon', value: 'Amazon' },
        { label: 'Noon', value: 'Noon' },
        { label: 'Dubai Store', value: 'Dubaistore' },
        { label: 'Ace', value: 'Ace' },
        { label: 'Flitit', value: 'Flitit' },
      ],
    },
  ];

  const optionGroup1 = [
    {
      label: 'Shipment Type',
      options: [
        { label: 'Amazon Easy Ship', value: 'Amazon Easy Ship' },
        { label: 'Amazon Express Ship', value: 'Amazon Express Ship' },
        { label: 'Amazon Retail Easy Ship', value: 'Amazon Retail Easy Ship' },
        { label: 'Noon Easy Ship', value: 'Noon Easy Ship' },
        { label: 'Carrefour Easy Ship', value: 'Carrefour Easy Ship' },
        { label: 'Amazon Self Ship', value: 'Amazon Self Ship' },
        { label: 'Noon Self Ship', value: 'Noon Self Ship' },
        { label: 'Dubaistore Self Ship', value: 'Dubaistore Self Ship' },
        { label: 'Flitit Self Ship', value: 'Flitit Self Ship' },
        { label: 'Ace Self Ship', value: 'Ace Self Ship' },
      ],
    },
  ];

  const getStatusStyle = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'open' || s === 'pending') return { cls: 'bg-soft-warning text-dark', label: s === 'pending' ? 'Pending' : 'New' };
    if (s === 'picked') return { cls: 'bg-soft-warning text-dark', label: 'Picked' };
    if (s === 'posted') return { cls: 'bg-soft-info text-dark', label: 'Posted' };
    if (s === 'confirmed') return { cls: 'bg-soft-info text-dark', label: 'Confirmed' };
    if (s === 'cancel' || s === 'canceled' || s === 'pending_payment') return { cls: 'bg-soft-danger text-danger', label: 'Canceled' };
    if (s === 'delivered' || s === 'completed') return { cls: 'bg-soft-success text-success', label: 'Delivered' };
    if (s === 'delivery_scheduled' || s === 'delivery scheduled') return { cls: 'bg-soft-success text-success', label: 'Delivery Scheduled' };
    if (s === 'rescheduled') return { cls: 'bg-soft-success text-success', label: 'Rescheduled' };
    if (s === 'material n/a') return { cls: 'bg-soft-warning text-dark', label: 'Material N/A' };
    if (s === '') return { cls: 'bg-soft-warning text-dark', label: 'Pending' };
    return { cls: 'bg-soft-dark text-dark', label: status };
  };

  return (
    <>
      <Row className="justify-content-between align-items-center dh-TabRow">
        <Col md={7} sm={6} xs={12} className="overflow-y-hidden">
          <Nav tabs className="nav-tabs-custom card-header-tabs flex-nowrap scrollNav dh-custom-tab">
            {['All', 'Open', 'Confirmed', 'posted', 'Picked', 'delivered', 'cancel', 'DmsNotFlow'].map((tab) => (
              <NavItem key={tab}>
                <NavLink
                  style={{ cursor: 'pointer' }}
                  className={classnames({ active: statusValue.activeTab === tab })}
                  onClick={() => toggleCustom(tab)}
                >
                  <span className="d-sm-block">
                    {tab === 'All' ? 'ALL' : tab === 'Open' ? 'NEW' : tab === 'Confirmed' ? 'CONFIRMED' : tab === 'posted' ? 'POSTED' : tab === 'Picked' ? 'SHIPPED' : tab === 'delivered' ? 'DELIVERED' : tab === 'cancel' ? 'CANCELED' : 'Dms Not Flow'}
                  </span>
                </NavLink>
              </NavItem>
            ))}
          </Nav>
        </Col>
        <Col md="auto" sm="auto" xs="auto" className="MobileView">
          <div className="search-box me-2 d-inline-block">
            <div className="position-relative">
              <Form.Control
                type="text"
                placeholder="Search"
                value={searchValue.search}
                id="listSearch"
                onChange={handleSearch}
              />
              <i className="bx bx-search-alt search-icon" />
            </div>
          </div>
          <a onClick={() => AdvanceFilterOnClick(ActiveFilter)} className="filterTxt">
            Filter <i className="bx bx-filter-alt"></i>
          </a>
        </Col>
      </Row>

      <ReactDrawer open={open} position={position} onClose={onDrawerClose} className="sideNavWidth">
        <Card className="card-h-100 OrderDetailsBox" style={{ overflowY: 'scroll' }}>
          <CardHeader>
            <Row className="mb-3">
              <Col><CardTitle>Advance Filter</CardTitle></Col>
              <Col className="textAlignRight">
                <button type="button" className="btn-close" onClick={onDrawerClose} aria-label="Close"></button>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col>
                <div className="mb-3">
                  <label className="form-label font-size-13 text-muted">Vendor</label>
                  <Select value={selectedVendor} onChange={setSelectedVendor} options={optionGroup} classNamePrefix="select2-selection" />
                </div>
              </Col>
              <Col>
                <div className="mb-3">
                  <label className="form-label font-size-13 text-muted">Shipment Type</label>
                  <Select value={selectedShipment} onChange={setSelectedShipment} options={optionGroup1} classNamePrefix="select2-selection" />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <button className="btn btn-success marginRiight" onClick={() => { setIsShipmentOrVendorUpdated(true); onDrawerClose(); }}>Apply</button>
                <button type="button" className="btn btn-outline-info waves-effect waves-light" onClick={AdvanceFilterClear}>Clear Filter</button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </ReactDrawer>

      <div className="table-responsive dt-table">
        {isLoading || isDataLoading ? <Spinner className="ms-2 sploader" color="primary" /> : null}
        {orderData?.length > 0 ? (
          <>
            <Table className="OrderListTable table mb-0">
              <thead>
                <tr>
                  <th>SI.No</th>
                  <th>Reference No</th>
                  <th>Vendor</th>
                  <th>Shipment Type</th>
                  <th>Name</th>
                  <th>Grand Total</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              {(orderData || []).map((order, index) => {
                pageIndex++;
                const orderDt = moment(new Date(order.created_at)).format('Do MMM, YYYY');
                const orderTime = moment(new Date(order.created_at)).format('h:mm:ss a');
                const { cls: stsBtn, label: statusLabel } = getStatusStyle(order.status);
                return (
                  <tbody key={order.entity_id || index}>
                    <tr>
                      <th scope="row">{pageIndex}</th>
                      <td nowrap="nowrap">
                        <strong>{order.reference_no}</strong>
                        <span className="highlightInfo2">{orderDt} {orderTime}</span>
                      </td>
                      <td>
                        <img
                          alt=""
                          width="120"
                          height="33"
                          className="img-thumbnail"
                          src={`https://assets.danubehome.com/media/assets/mktplace/sellers/${order?.marketplace_id?.toLowerCase()}.png`}
                        />
                      </td>
                      <td>{order.shipping_method}</td>
                      <td>
                        {order.full_name}
                        <span className="noTxtWrap" title={order?.region}>{order?.country}-{order?.region}</span>
                      </td>
                      <td>{order.grand_total}</td>
                      <td><Badge className={stsBtn}>{statusLabel}</Badge></td>
                      <td>
                        <a
                          href={`/storders/${order?.id}?order_mode=split`}
                          type="button"
                          className="btn btn-sm btn-outline-warning waves-effect waves-light"
                        >
                          <i className="mdi mdi-eye-outline"></i>
                        </a>
                        {order?.awb_pdf
                          ? order.awb_pdf.split(',').map((file, i) => (
                              <a key={i} href={`${fileUrl}${file.trim()}`} download target="_blank" rel="noopener noreferrer" style={{ paddingLeft: '10px' }}>
                                <Button outline size="sm" color="success" className="waves-effect waves-light">
                                  <i className="bx bx-download"></i>
                                </Button>
                              </a>
                            ))
                          : null}
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </Table>

            <div className="dataTblFooter">
              <div>
                <Dropdown isOpen={btnprimary1} toggle={() => setBtnprimary1(!btnprimary1)}>
                  <DropdownToggle tag="button" className="btn btn-dark">
                    {limitValue.limit} Items <i className="mdi mdi-chevron-down" />
                  </DropdownToggle>
                  <DropdownMenu>
                    {limitByValues.map((limit, i) => (
                      <DropdownItem key={i} href="#" onClick={() => handleLimit(limit)}>{limit} Items</DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
              <div className="d-flex justify-content-center">
                <Pagination
                  id="listPage"
                  value={paginationValue.page}
                  totalPages={listOrders?.recordsTotal}
                  onChange={(e) => handlePagination(e)}
                />
              </div>
            </div>
          </>
        ) : (
          <Table className="OrderListTable table mb-0">
            <thead>
              <tr>
                <th>SI.No</th>
                <th>Reference No</th>
                <th>Vendor</th>
                <th>Shipment Type</th>
                <th>Name</th>
                <th>Grand Total</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr><td colSpan={8}>No Records found</td></tr>
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default STOrderList;
